/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planshare_Import_OpenInputs */

const en_us2_planshare_import_open = /** @type {(inputs: Planshare_Import_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the plan`)
};

const pt_br2_planshare_import_open = /** @type {(inputs: Planshare_Import_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver plano`)
};

const pt_pt2_planshare_import_open = /** @type {(inputs: Planshare_Import_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver plano`)
};

/** @type {(inputs: Planshare_Import_OpenInputs) => LocalizedString} */
const es_419_planshare_import_open = en_us2_planshare_import_open;

/** @type {(inputs: Planshare_Import_OpenInputs) => LocalizedString} */
const fr_fr2_planshare_import_open = en_us2_planshare_import_open;

/** @type {(inputs: Planshare_Import_OpenInputs) => LocalizedString} */
const de_de2_planshare_import_open = en_us2_planshare_import_open;

/** @type {(inputs: Planshare_Import_OpenInputs) => LocalizedString} */
const it_it2_planshare_import_open = en_us2_planshare_import_open;

/**
* | output |
* | --- |
* | "See the plan" |
*
* @param {Planshare_Import_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const planshare_import_open = /** @type {((inputs?: Planshare_Import_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planshare_Import_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_planshare_import_open(inputs)
	if (locale === "es-419") return es_419_planshare_import_open(inputs)
	if (locale === "pt-PT") return pt_pt2_planshare_import_open(inputs)
	if (locale === "fr-FR") return fr_fr2_planshare_import_open(inputs)
	if (locale === "de-DE") return de_de2_planshare_import_open(inputs)
	if (locale === "it-IT") return it_it2_planshare_import_open(inputs)
	return en_us2_planshare_import_open(inputs)
});
export { planshare_import_open as "planshare.import_open" }